<template>
    <div>
        <q-select
                v-model="entidadSelected"
                value="name"
                data-cy="list-entidad"
                outlined
                :options="listEntidadOpts"
                option-value="id"
                option-label="name"
                :class="'input'"
                @input="changeEntidad"
              >
              <template v-slot:no-option>
                  <q-item>
                    <q-item-section class="text-grey">
                      Sin resultados
                    </q-item-section>
                  </q-item>
                </template>
              </q-select>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  computed: {
    ...mapGetters({
      isAdmin: 'PF/isAdmin',
      isSuperAdmin: 'PF/isSuperAdmin'
    })
  },
  data () {
    return {
      entidadSelected: null,
      listEntidadOpts: []
    };
  },
  methods: {
    async _setEntidades () {
      let idUser = this.$store.getters['PF/userId'];
      if (idUser) {
        let request = {
          controller: this.isSuperAdmin ? `/Entidad` : `/Entidad/User/${idUser}`
        };
        await this.$store
          .dispatch('PF/getSuit', request)
          .then((response) => {
            this.listEntidadOpts = response.data.filter(entidad => entidad.visible === true);
            this.entidadSelected = this.listEntidadOpts?.length > 0 ? this.listEntidadOpts[0] : null;
            this.changeEntidad(this.entidadSelected);
          })
          .catch((err) => {
            this.showError(err.message);
          });
      }
    },
    changeEntidad (data) {
      this.$eventHub.$emit('refreshIndicadoresYServiciosDigitales', data);
    }
  },
  async created () {
    await this._setEntidades();
  }
};
</script>
<style lang="scss" scoped>
  .input {
    background-color: #fff;
    border-radius: 10px;
  }
  label.q-field {
    width: 332px !important;
    margin-left: 15px;
  }
  @media (max-width: 640px) {
    ::v-deep {
      label.q-field {
        width: 232px !important;
      }
    }
  }
</style>
